import React from "react";

export default function AnswerWindow({ sentence }: { sentence: string }) {
  return (
    <div>
      <div className="answer-box">
        {sentence}
        <br />
      </div>
    </div>
  );
}
